/**
 * Feedback intake → Lambda Function URL → SES.
 * Override at build time with VITE_FEEDBACK_ENDPOINT if the URL changes.
 */
const endpointFromEnv = (() => {
  try {
    // Vite injects import.meta.env; cast avoids TS project-reference edge cases.
    return String(
      (import.meta as unknown as { env?: { VITE_FEEDBACK_ENDPOINT?: string } }).env
        ?.VITE_FEEDBACK_ENDPOINT || '',
    );
  } catch {
    return '';
  }
})();

export const feedbackConfig = {
  endpoint:
    endpointFromEnv ||
    'https://iizaxtju3odp6eyzlytwdeqm2u0jeybm.lambda-url.us-west-2.on.aws/',
  mailto: 'feedback@boozeratio.com',
  subjectPrefix: '[BoozeRatio feedback]',
} as const;
